module.exports = __webpack_public_path__ + "img/4-small.5ebb02c7.png";